exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4 {\n  display: inline-block;\n}\n\n.content {\n  margin-top: 50px;\n}\n\n.table-actions-container {\n  float: right;\n}\n\n.table-action {\n  float: left;\n  display: table;\n  color: #fb9c00;\n  padding: 10px 10px 0 10px;\n}\n\n.table-action i {\n  font-size: 22px;\n  padding-right: 10px;\n}\n\n.table-action span {\n  font-size: 13px;\n  display: table-cell;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.table-action span:hover {\n  opacity: .5;\n}\n\n.table {\n  line-height: normal;\n}\n\ntable tr td, table tr th {\n  font-size: 14px !important;\n}\n\nthead tr th {\n  text-align: center;\n}\n\ntbody tr td {\n  text-align: center;\n}\n\ntbody tr {\n  cursor: pointer;\n}\n\ntbody tr:hover {\n  background: #EEEEEE;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/simulation-list/simulation-list.component.css
// module id = ../../../../../src/app/components/simulation-list/simulation-list.component.css
// module chunks = main